import React, { useState } from 'react';
import useEmailNotifications from '../../hooks/useEmailNotifications';
import CAdminUserEmailNotificationTable from './CAdminUserEmailNotificationTable';
import IEmailNotification from '../../interfaces/IEmailNotification';
import CAdminEmailNotificationFilters from '../email-notifications/CAdminEmailNotificationFilters';

const FAdminUserEmailNotifications = () => {
	const { data: emailNotifications } = useEmailNotifications();

	const [emailNotificationsFiltered, setEmailNotificationsFiltered] = useState<IEmailNotification[]>([]);

	return (
		<>
			<CAdminEmailNotificationFilters
				emailNotifications={emailNotifications ?? []}
				onChange={(values) => setEmailNotificationsFiltered(values)}
			/>
			<CAdminUserEmailNotificationTable emailNotifications={emailNotificationsFiltered} />
		</>
	);
};

export default FAdminUserEmailNotifications;
